<template>
  <div class="cm-container">
    <div class="cm-button" @click="toggle()" :class="{open: isOpen}" ref="button">
      <ThreeDotsHorizontal />
    </div>
    <transition name="zoom" mode="out-in">
      <div class="cm-menu" v-show="isOpen" v-closable="{ exclude: ['button'], handler: 'onClose'}">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
import ThreeDotsHorizontal from "@/components/icons/ThreeDotsHorizontal";

let handleOutsideClick;

export default {
  data: () => {
    return {
      open: false,
      handleOutsideClick
    };
  },
  computed: {
    isOpen() {
      return this.open
    }
  },
  mounted() {
    this.$root.$on('closeAllContextMenu', this.onClose);
  },
  directives: {
    closable: {
      bind(el, binding, vnode) {
        handleOutsideClick = (e) => {
          e.stopPropagation();
          const { handler, exclude } = binding.value;
          let clickedOnExcludedEl = false;

          exclude.forEach(refName => {
            if (!clickedOnExcludedEl) {
              const excludedEl = vnode.context.$refs[refName];
              if (excludedEl){
                clickedOnExcludedEl = excludedEl.contains(e.target);
              }
            }
          });

          if (!el.contains(e.target) && !clickedOnExcludedEl) {
            vnode.context[handler]();
          }

        }

        document.addEventListener('click', handleOutsideClick);
        document.addEventListener('touchstart', handleOutsideClick);
      },
      unbind() {
        document.removeEventListener('click', handleOutsideClick);
        document.removeEventListener('touchstart', handleOutsideClick);
      }
    }
  },
  methods: {
    toggle() {
      if (this.open) {
        this.onClose();
      } else {
        this.$root.$emit('closeAllContextMenu');
        this.open = true;
      }
    },
    onClose() {
      this.open = false;
    }
  },
  components: {
    ThreeDotsHorizontal
  },
};
</script>

<style lang="scss">
.cm-container {
  .cm-button {
    width: 28px;
    height: 28px;
    font-size: 1.2em;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    opacity: 0.8;
    color: #fff;
    &:hover {
      opacity: 1;
    }
  }
  .cm-menu {
    position: absolute;
    width: auto;
    max-width: 130px;
    margin: 0 0 0 8px;
    border-radius: 2px;
    background-color: #555555;
    border: 1px solid #777777;
    padding: 0 0 0 10px;
    font-size: 12px;
    z-index: 999;

    box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);

    .cm-item {
      opacity: 0.85;
      color: #fff;

      padding: 10px 10px 10px 0;
      border-bottom: 1px solid #777777;

      &:last-child {
        border-bottom: none;
      }

      &:hover {
        opacity: 1;
      }

      &.red {
        color: #ff2c2c;
      }
    }
  }
}
</style>
